// CardLoader.js
import React from "react";


const CardLoader = () => {
  return (
    <div className="card-loader">
      <div className="image-skeleton"></div>
      <div className="text-skeleton title"></div>
      <div className="text-skeleton subtitle"></div>
      <div className="text-skeleton"></div>
    </div>
  );
};

export default CardLoader;

